<template>
  <div class="save-checklist-dialog-share-type">
    <app-tile-group
      v-model="shareType"
      class="share-type-group"
      :options="shareTypeOptions"
      layout="vertical"
    />
  </div>
</template>

<script>
  import { SHARE_TYPE_OPTIONS } from '@/common/utils/shareTypes.ts'

  export default {
    name: 'SaveChecklistDialogShareType',
    props: {
      defaultShareType: {
        type: String,
        required: true,
      },
      withoutPrivateOption: {
        type: Boolean,
        default: false,
      },
      withoutPublicOption: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        shareType: this.defaultShareType,
      }
    },
    computed: {
      shareTypeOptionsValues () {
        let values = Object.values(SHARE_TYPE_OPTIONS)
        if (this.withoutPrivateOption) {
          values = values.filter(item => item !== SHARE_TYPE_OPTIONS.PRIVATE)
        }
        if (this.withoutPublicOption) {
          values = values.filter(item => item !== SHARE_TYPE_OPTIONS.PUBLIC)
        }
        return values
      },
      shareTypeOptions () {
        return this.shareTypeOptionsValues.map(option => ({
          value: option,
          label: this.withoutPrivateOption
            ? this.$t(`project.checklist.dialogs.ImportChecklistDialog.accessRights.shareTypeOptions.${option}`)
            : this.$t(`project.checklist.dialogs.SaveChecklistDialog.sharingOptions.shareTypeOptions.${option}`),
        }))
      },
    },
    watch: {
      shareType (value) {
        this.$emit('change-share-type', value)
      },
    },
  }
</script>

<style lang="scss" scoped>
.save-checklist-dialog-share-type {
  .share-type-group {
    margin-top: 16px;
  }
}
</style>
